import seoConfig from './publicPages.json';

export const SITE_URL = seoConfig.siteUrl;
export const DEFAULT_OG_IMAGE = seoConfig.ogImage;
export const PUBLIC_SEO_PAGES = seoConfig.pages;

export function normalizeSeoPath(pathname) {
  if (!pathname) return '/';
  const clean = String(pathname).split('?')[0].split('#')[0];
  if (clean === '' || clean === '/') return '/';
  return clean.endsWith('/') ? clean : `${clean}/`;
}

export function canonicalUrl(path) {
  if (!path || path === '/') return `${SITE_URL}/`;
  return `${SITE_URL}${normalizeSeoPath(path)}`;
}

export function findPublicSeoPage(pathname) {
  const path = normalizeSeoPath(pathname);
  return PUBLIC_SEO_PAGES.find((page) => page.path === path) || null;
}

export function getPublicSeoPage(pathname) {
  const page = findPublicSeoPage(pathname);
  if (!page) {
    throw new Error(`Missing SEO config for ${pathname}`);
  }
  return page;
}

export function buildJsonLd(page) {
  const url = canonicalUrl(page.path);
  if (page.schemaType === 'WebSite') {
    return {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Organization',
          name: 'Complimate',
          url: SITE_URL,
          logo: DEFAULT_OG_IMAGE,
        },
        {
          '@type': 'WebSite',
          name: 'Complimate',
          url: SITE_URL,
          description: page.description,
        },
      ],
    };
  }

  return {
    '@context': 'https://schema.org',
    '@type': page.schemaType || 'WebPage',
    name: page.title,
    description: page.description,
    url,
    isPartOf: {
      '@type': 'WebSite',
      name: 'Complimate',
      url: SITE_URL,
    },
  };
}
